module.exports = __webpack_public_path__ + "static/img/member-header.ecf3af59.png";